<template>
<v-dialog :retain-focus="false" max-width="400" v-model="getLoginShow" persistent>
  <router-view></router-view>
</v-dialog>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
export default {
  computed: {
    ...mapGetters('View', [
      'getLoginShow'
    ])
  },
  methods: {
    ...mapActions('View', [
      'setLoginShow'
    ])
  },
  created(){
    this.setLoginShow(true);
  }
}
</script>
